import "../../stylesheets/App.css";
import "../../stylesheets/Header.css";
import React, { useState, useEffect, useRef } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link, useNavigate } from "react-router-dom";

function Header(props) {
  const navRef = useRef(null);
  const submenuRef = useRef(null);

  const [menu, setMenu] = useState(false);
  const [submenu, setSubmenu] = useState(false);
  const [isAdmin, setIsAdmin] = useState(0);

  // Evitamos usar "key" (palabra reservada en React para listas)
  const [keywordsLocal, setKeywordsLocal] = useState(props.keywords || "");

  const navigate = useNavigate();

  const apiCall = (url, consecuencia) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => consecuencia(data))
      .catch((error) => console.log(error));
  };

  const updateIsAdmin = (data) => {
    setIsAdmin(data.data);
  };

  // Mantener sincronizado el input si el padre cambia keywords
  useEffect(() => {
    setKeywordsLocal(props.keywords || "");
  }, [props.keywords]);

  // Traer isAdmin solo si hay user logueado
  useEffect(() => {
    const userInfoRaw = localStorage.getItem("user-info");
    if (userInfoRaw) {
      const userInfo = JSON.parse(userInfoRaw);
      apiCall(
        process.env.REACT_APP_API_BASE_URL + "/admin/is-admin/" + userInfo.idUser,
        updateIsAdmin
      );
    }
  }, []);

  // Abrir/cerrar menú (con checks para no romper si no existe html-ref)
  useEffect(() => {
    const nav = navRef.current;
    const html = document.getElementById("html-ref");
    if (!nav || !html) return;

    if (menu) {
      nav.classList.add("active");
      html.classList.add("block-scroll");
    } else {
      nav.classList.remove("active");
      html.classList.remove("block-scroll");
    }
  }, [menu]);

  // Submenu seguro
  useEffect(() => {
    const sub = submenuRef.current;
    if (!sub) return;

    if (submenu) sub.classList.add("active");
    else sub.classList.remove("active");
  }, [submenu]);

  const toggleMenu = () => setMenu((prev) => !prev);

  const closeMenu = () => {
    setMenu(false);
  };

  const logout = () => {
    const html = document.getElementById("html-ref");
    if (html) html.classList.remove("block-scroll");

    localStorage.removeItem("user-info");
    // opcional: también podrías limpiar user-email si querés
    // localStorage.removeItem("user-email");

    navigate("/login");
  };

  const toggleSubmenu = () => {
    setSubmenu((prev) => !prev);
    const rankingLi = document.getElementById("ranking-li");
    if (rankingLi) rankingLi.classList.toggle("active");
  };

  // Enter para buscar
  const onKeyUpSearch = (e) => {
    if (e.key === "Enter" && props.setKeywords) {
      props.setKeywords(keywordsLocal);
    }
  };

  // Botón back: si no hay historial, lo mandamos a home o login
  const goBack = () => {
    if (window.history.length > 1) window.history.back();
    else navigate(localStorage.getItem("user-info") ? "/" : "/login");
  };

  return (
    <>
      <header>
        <div className="header-container-flex">
          <button className="header-btn btn-prev" onClick={goBack}>
            <FontAwesomeIcon icon={solid("chevron-left")} />
          </button>

          <div className="search-container" id="search-container">
            <button className="search-btn" type="button">
              <FontAwesomeIcon icon={solid("magnifying-glass")} />
            </button>
            <input
              type="text"
              placeholder="Buscar por equipos, paises"
              value={keywordsLocal}
              onChange={(e) => setKeywordsLocal(e.target.value)}
              onKeyUp={onKeyUpSearch}
            />
          </div>

          <div>
            <button
              className="header-btn"
              id="header-menu-btn"
              onClick={toggleMenu}
            >
              <FontAwesomeIcon icon={solid("bars")} />
            </button>
          </div>
        </div>
      </header>

      <nav className="nav-bar" ref={navRef}>
        <div className="nav-out" onClick={closeMenu}></div>

        <div className="nav-container">
          <ul>
            <div className="div-img">
              <img
                src={process.env.PUBLIC_URL + "/images/Logo-Menu-HMQ.png"}
                alt=""
              />
            </div>

            {isAdmin === 1 ? (
              <>
                <Link to="/admin" onClick={closeMenu}>
                  <li>Gestión de Decimo Mundialista</li>
                </Link>

                <Link to="/qr-admin" onClick={closeMenu}>
                  <li>Gestión de QRs</li>
                </Link>

                <li className="item-with-childrens" id="ranking-li">
                  <div onClick={toggleSubmenu}>
                    Ranking <FontAwesomeIcon icon={solid("chevron-down")} />
                  </div>
                  <ul className="submenu-list-ranking" ref={submenuRef}>
                    <Link to="/stage-ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Fase</li>
                    </Link>
                    <Link to="/ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Global</li>
                    </Link>
                  </ul>
                </li>
              </>
            ) : (
              <>
                <Link to="/" onClick={closeMenu}>
                  <li>Pronósticos</li>
                </Link>

                <Link to="/my-score" onClick={closeMenu}>
                  <li>Mis puntos</li>
                </Link>

                <li className="item-with-childrens" id="ranking-li">
                  <div onClick={toggleSubmenu}>
                    Ranking <FontAwesomeIcon icon={solid("chevron-down")} />
                  </div>
                  <ul className="submenu-list-ranking" ref={submenuRef}>
                    <Link to="/stage-ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Fase</li>
                    </Link>
                    <Link to="/ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Global</li>
                    </Link>
                  </ul>
                </li>

                <Link to="/rules" onClick={closeMenu}>
                  <li>Reglas</li>
                </Link>

                <Link to="/awards" onClick={closeMenu}>
                  <li>Premios</li>
                </Link>

                <Link to="/profile" onClick={closeMenu}>
                  <li>Mi perfil</li>
                </Link>
              </>
            )}

            <hr className="line-menu" />

            <div className="logout-container">
              <img
                src={process.env.PUBLIC_URL + "/images/assets/logout.png"}
                alt=""
              />
              <p className="logout-p" onClick={logout}>
                Cerrar sesión
              </p>
            </div>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Header;
